var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-bullet",class:[
    _vm.getCollorClass() ? _vm.getCollorClass() : '',
    _vm.number ? 'numbered' : '' ]},[(_vm.number)?_c('span',[_vm._v(_vm._s(_vm.number))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }